import { call, put, takeLatest } from 'redux-saga/effects'
import { getCandidateFilter } from '@/core/apiModules/candidateFilters'
import { candidateFiltersModule, stickyFiltersModule } from '../modules'
import { errorHandler } from '@/core/helpers/errorHelpers'

function* fetchDetailSaga({ payload }) {
  yield put(candidateFiltersModule.toggleLoading(true))

  try {
    const response = yield getCandidateFilter(payload.id)
    yield put(stickyFiltersModule.updateDetailSuccess(response))
  } catch (err) {
    yield call(errorHandler, err)
  }

  yield put(candidateFiltersModule.toggleLoading(false))
}

export default function* watchCandidateFiltersSaga() {
  yield takeLatest(candidateFiltersModule.FETCH_DETAIL, fetchDetailSaga)
}
